export { default } from './StarsRatingBar';
